import axios from "axios";
import { InteractionRequiredAuthError } from '@azure/msal-browser';

// ✅ Get MSAL token directly — replaces getJWTToken + encryption
const getAPIToken = async (instance) => {
    try {
        const activeAccount = instance.getActiveAccount();
        if (!activeAccount) {
            console.error('No active account found');
            return null;
        }

        const tokenResponse = await instance.acquireTokenSilent({
            account: activeAccount,
            scopes: ['openid', 'profile', 'email']
        });

        return tokenResponse.idToken;

    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            try {
                await instance.acquireTokenRedirect({
                    scopes: ['openid', 'profile', 'email']
                });
            } catch (redirectError) {
                console.error('Error acquiring token via redirect:', redirectError);
            }
        } else {
            console.error('Error acquiring token silently:', error);
        }
        return null;
    }
};

const getUserProfile = async (instance) => {
    const activeAccount = instance.getActiveAccount();
    try {
        const accessToken = await instance.acquireTokenSilent({
            account: activeAccount,
            scopes: ['User.Read', 'User.ReadBasic.All']
        });

        const response = await fetch('https://graph.microsoft.com/v1.0/me', {
            headers: {
                Authorization: `Bearer ${accessToken.accessToken}`,
            },
        });

        if (response.ok) {
            const pdata = await response.json();
            return pdata;
        } else {
            console.error('Failed to fetch user profile:', response.statusText);
            return "not found";
        }
    } catch (error) {
        console.error('Error fetching user profile:', error);
        if (error instanceof InteractionRequiredAuthError) {
            alert("Session expired. Please reload the page to re-authenticate.");
        } else {
            console.error("Error acquiring token:", error);
        }
        return null;
    }
};

const getProfilePhoto = async (instance) => {
    const activeAccount = instance.getActiveAccount();
    try {
        const accessToken = await instance.acquireTokenSilent({
            account: activeAccount,
            scopes: ['User.Read', 'User.ReadBasic.All']
        });

        const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
            headers: {
                Authorization: `Bearer ${accessToken.accessToken}`,
            },
        });

        if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            return url;
        } else {
            console.error('Failed to fetch profile photo:', response.statusText);
            return "not found";
        }
    } catch (error) {
        console.error('Error fetching profile photo:', error);
        return null;
    }
};

// ✅ Backward compatibility export for getJWTToken
const getJWTToken = async () => {
    // Return token from localStorage if available (fallback)
    const token = localStorage.getItem('ItemToken');
    if (token) {
        return token;
    }
    return null;
};

export { getAPIToken, getJWTToken, getUserProfile, getProfilePhoto };